import React from "react";

const SettingItem = ({ title, children }) => {
  const collapseId = `collapse-${title.replace(/\s+/g, "-")}`; // Unique ID for Bootstrap collapse

  return (
    <div>
      <p className="d-inline-flex gap-1">
        <a
          className="text-decoration-none"
          data-bs-toggle="collapse"
          href={`#${collapseId}`}
          aria-expanded="false"
          aria-controls={collapseId}
          style={{ fontSize: "14px" }}
        >
          {title}
        </a>
      </p>
      <div className="collapse" id={collapseId}>
        <div className=" ">{children}</div>
      </div>
    </div>
  );
};

export default SettingItem;
